<template>
    <div class="container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Add User</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <!-- {{usertype}} -->
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <center><v-btn @click="getUserCard()" small :loading="loader" class="mb-2 button">Get Users</v-btn>
                        <v-btn v-if="allowed_add_user" small class="mb-2 button" v-on="on">New User</v-btn>
                    </center>
                </template>
                <v-card>
                    <v-card-title class="brand onBrand--text">
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row dense>
                                <v-col cols="12">
                                    <v-text-field dense v-model.trim="editedItem.username" label="Username"
                                        :suffix="uid_domain" persistent-hint :disabled="editedIndex != -1"
                                        :hint="editedIndex==-1?'':'noneditable'" :filled="editedIndex==-1?false:true"
                                        :error="errorMsg.username?true:false"
                                        :error-messages="errorMsg.username?'Required':''"></v-text-field>
                                    <span v-if="editedIndex==-1">{{editedItem.username}}{{uid_domain}}</span>
                                </v-col>
                                <v-col cols="1">
                                    <v-hidden v-model="editedItem.id" label="id"></v-hidden>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-select dense v-model="editedItem.usertype" :items="usertype"
                                        :readonly="editedIndex==-1?false:true" item-text="name" item-value="id"
                                        label="User Type" persistent-hint :disabled="editedIndex != -1"
                                        :hint="editedIndex==-1?'Select user type :: Teacher, Student etc':'noneditable'"
                                        :filled="editedIndex==-1?false:true" return-object single-line
                                        :error="errorMsg.userType?true:false"
                                        :error-messages="errorMsg.userType?'Required':''"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="3" md="5">
                                    <v-checkbox v-model="editedItem.isloginblocked" color="success"
                                        label="isBlocked?"></v-checkbox>
                                    <v-checkbox v-model="reset_password" color="success" v-if="this.editedIndex!=-1"
                                        label="Reset Password"></v-checkbox>
                                    <v-checkbox v-model="remove_access" color="success" v-if="this.editedIndex!=-1"
                                        label="Remove Access"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button" @click="close">Cancel</v-btn>
                        <v-btn class="button" @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-card class="box" v-if="show_user_card">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Fetch Users</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon><b>User Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="usertype_fetch"
                            :items="usertype" item-text="name" item-value="id" label="User Type" outlined
                            persistent-hint hint="Please Select User Type" />
                    </v-col>
                    <v-col cols="12" sm="1"><br>
                        <br>
                        <v-btn v-if="usertype_fetch" @click="getuser()" small :loading="loader"
                            class="mb-2 button">Fetch Users</v-btn>
                    </v-col>
                </v-row>
            </v-card>


            <v-data-table :headers="headers" :items="userlist" :search="search" v-if="userlist!=''">
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Users List</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" background-color="white" label="Search"
                            single-line hide-details></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:item.isloginblocked="{ item }">
                    <span v-if="item.isloginblocked">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>

                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
            </v-data-table>
        </v-card>
        <!-- <v-app id="inspire">
            <template v-if="load==true">
                <v-data-table :headers="headers" :items="userlist" sort-by="roletype.name" dense class="elevation-1 mytable" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>User Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        
                        <span style="width: 20px;"> </span>
                        <v-row dense justify="center" class="p-0 m-0">
                            <v-col sm="3" md="3" cols="12" class="p-0 m-0"> </v-col>
                            <v-col sm="6" md="6" cols="12" class="p-0 m-0">
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                            </v-col>
                            <v-col sm="3" md="3" cols="12">
                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn small class="mb-2 button" v-on="on">New User</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title class="toolbar">
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            dense
                                                            v-model.trim="editedItem.username"
                                                            label="Username"
                                                            :suffix="uid_domain"
                                                            persistent-hint
                                                            :disabled="editedIndex != -1"
                                                            :hint="editedIndex==-1?'':'noneditable'"
                                                            :filled="editedIndex==-1?false:true"
                                                            :error="errorMsg.username?true:false"
                                                            :error-messages="errorMsg.username?'Required':''"
                                                        ></v-text-field>
                                                        <span v-if="editedIndex==-1">{{editedItem.username}}{{uid_domain}}</span>
                                                    </v-col>
                                                    <v-col cols="1">
                                                        <v-hidden v-model="editedItem.id" label="id"></v-hidden>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-select
                                                            dense
                                                            v-model="editedItem.usertype"
                                                            :items="usertype"
                                                            :readonly="editedIndex==-1?false:true"
                                                            item-text="name"
                                                            item-value="id"
                                                            label="User Type"
                                                            persistent-hint
                                                            :disabled="editedIndex != -1"
                                                            :hint="editedIndex==-1?'Select user type :: Teacher, Student etc':'noneditable'"
                                                            :filled="editedIndex==-1?false:true"
                                                            return-object
                                                            single-line
                                                            :error="errorMsg.userType?true:false"
                                                            :error-messages="errorMsg.userType?'Required':''"
                                                        ></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="6" sm="3" md="2">
                                                        <v-checkbox v-model="editedItem.isloginblocked" color="success" label="isBlocked?"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="button" @click="close">Cancel</v-btn>
                                            <v-btn class="button" @click="save">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.isloginblocked="{ item }">
                        <span v-if="item.isloginblocked">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-avatar size="25" class="edit-avatar">
                                <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>

                    <template v-slot:no-data>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                    </template>
                </v-data-table>
            </template>
        </v-app> -->
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            isallowed:false,
            errorMsg: { username: false, userType: false },
            show_user_card:false,usertype_fetch:"",
            search: "",
            // extraBreadcrumbItems: [
              

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            uid_domain: "",
            load: false,
            overlay: false,
            dialog: false,
            userlist: [],
            usertype: {},
            loader:false,
            allowed_add_user:null,
            reset_password:false,
            remove_access:false,
            headers: [
                { text: "Username", value: "username" },
                { text: "User Type", value: "usertype.name" },
                { text: "Is Blocked", value: "isloginblocked" },
                { text: "Actions", value: "action", sortable: false },
            ],

            editedIndex: -1,
            editedItem: {
                username: "",
                id: "",
                isloginblocked: false,
                usertype: {
                    id: "",
                    name: "",
                },
            },
            defaultItem: {
                username: "",
                id: "",
                isloginblocked: false,
                usertype: {
                    id: "",
                    name: "",
                },
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New User" : "Edit User";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
        },
        mounted() {
            this.overlay = true;
            axios
                .post("/roleManagement/adduser")
                .then((res) => {
                   if (res.data.flag == "YES") {
                        //  this.userlist = res.data.userlist;
                        this.usertype = res.data.usertype;
                        this.uid_domain = res.data.uid_domain;
                        this.allowed_add_user = res.data.allowed_add_user
                        this.load = true;
                        this.overlay = false;
                    } else if (res.data.flag == "No"){
                        this.showSnackbar("red", res.data.snackbar);
                        this.isallowed=res.data.isallowed
                        this.overlay = false;
          }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },

        methods: {
            getUserCard(){
                this.show_user_card=true
            },
            initializeErrorMsgFalse() {
                this.errorMsg.username = false;
                this.errorMsg.userType = false;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                this.editedIndex = this.userlist.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                const index = this.userlist.indexOf(item);
                confirm("Are you sure you want to delete this item?") && this.userlist.splice(index, 1);
            },

            close() {
                this.dialog = false;
                this.initializeErrorMsgFalse();
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
                this.reset_password=false;
                this.remove_access=false;
            },
            getuser() {
                const data = {
                    usertype: this.usertype_fetch,
                  }
                this.loader = true
                axios
                    .post("/roleManagement/getuser",data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.userlist = res.data.userlist;
                            console.log(this.userlist);
                            this.usertype = res.data.usertype;
                            this.uid_domain = res.data.uid_domain;
                            this.loader = false
                        } else {
                             this.loader = false
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                         this.loader = false
                    });
            },
            save() {
                this.initializeErrorMsgFalse();
                if (this.editedIndex > -1) {
                    //edit
                    if (this.isValidated()) {
                        const payload = {
                                ...this.editedItem,
                                reset_password: this.reset_password,
                                remove_access: this.remove_access
                        };
                        axios
                            .post("/roleManagement/edituserAndAccess", payload)
                            .then((res) => {
                                if (res.data.msg == "200") {
                                    Object.assign(this.userlist[this.editedIndex], this.editedItem);
                                    this.showSnackbar("#4caf50", res.data.snackbar || "User Updated Successfully..."); // show snackbar on success
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });
                    }
                    this.close();
                } else {
                    //new
                    if (this.isValidated()) {
                        console.log("==> " + this.uid_domain);
                        console.log("==> " + this.editedItem.username);
                        this.editedItem.username += this.uid_domain;
                        axios
                            .post("/roleManagement/addnewuser", this.editedItem)
                            .then((res) => {
                                 if (res.data.flag == "YES") {
                                    console.log("==> " + res.data);
                                    this.userlist.push(this.editedItem);
                                    this.showSnackbar("#4caf50", "New User Updated Successfully..."); // show snackbar on success
                                } else if (res.data.flag == "No"){
                                this.showSnackbar("red", res.data.snackbar);
                                this.isallowed=res.data.isallowed
                                this.overlay = false;
                            }
                                
                                else if (res.data.msg == "300") {
                                    this.showSnackbar("#4caf50", res.data.description); // show snackbar on success
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                                this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                            });

                        this.close();
                    }
                }
            },

            isValidated() {
                //alert('I am in isValidated()'+this.editedItem.usertype.id)
                if (this.editedItem.username && this.editedItem.usertype.id) {
                    return true;
                } else {
                    if (!this.editedItem.username) {
                        this.errorMsg.username = true;
                    }
                    if (!this.editedItem.usertype.id) {
                        this.errorMsg.userType = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()

        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
